import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
  useToast,
} from "@chakra-ui/react";
import { deleteNDR } from "api/ndr";

const DeleteNDRAction = ({ row, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const result = await deleteNDR(row.row._id, toast);
      
      // Even if result is undefined, consider it successful if no error was thrown
      toast({
        title: "NDR deleted successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      
      if (onUpdate) {
        onUpdate();
      }
      
      handleClose();
    } catch (error) {
      console.error("Delete error:", error);
      toast({
        title: "Error deleting NDR",
        description: error.message || "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        size="sm"
        colorScheme="red"
        onClick={handleOpen}
        variant="outline"
      >
        Delete
      </Button>

      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete NDR</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              Are you sure you want to delete the NDR "{row.name}"? This action cannot be undone.
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={handleClose}>
              Cancel
            </Button>
            <Button
              colorScheme="red"
              onClick={handleDelete}
              isLoading={isLoading}
              loadingText="Deleting..."
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DeleteNDRAction;
